import { rem } from 'theme/mixins/calculate';

const borderRadius = {
  base: rem(9),
  button: rem(6),
  input: rem(4),
};

export default borderRadius;
